export const getLocalAccessToken = () => localStorage.getItem('access_token');

export const setLocalAccessToken = (token, date, expiresIn) => {
  const storage = localStorage;

  storage.setItem('access_token', token);
  storage.setItem('access_token_date', date);
  storage.setItem('access_token_expires_in', expiresIn);
};

export const removeLocalAccessToken = () => {
  const storage = localStorage;

  storage.removeItem('access_token');
  storage.removeItem('access_token_date');
  storage.removeItem('access_token_expires_in');
  storage.removeItem('refresh_token');
};

export const getLocalRefreshToken = () => localStorage.getItem('refresh_token');

export const setLocalRefreshToken = (token) => {
  const storage = localStorage;

  storage.setItem('refresh_token', token);
};
